import { _deserializable } from '../_deserializable';

export class MinimumRequiredDateRequest extends _deserializable {

  public orderDate: Date;

}
